var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _vm.checkedRow.length ? _c('div', { staticClass: "batch-modular" }, [_vm._v("\n  已选择" + _vm._s(_vm.checkedRow.length) + "项\n  "), _c('div', { staticClass: "batch-right" }, _vm._l(_vm.batchBtnOption, function (btn, index) {
    return _c('el-button', { key: index, attrs: { "type": "text", "loading": btn.name === '下载' ? _vm.downloadLoading : false }, on: { "click": function click($event) {
          return _vm.handleBatchClick(btn);
        } } }, [_vm._v("\n      " + _vm._s(btn.name) + "\n    ")]);
  }), 1)]) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };